import React from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './sidebar'
import ScrollToTop from './ScrollToTop'


function Layout() {
  return (
    <>
      <div className='d-flex'>
   <ScrollToTop/>
         
        <Sidebar />
        <Outlet />
      </div>
    </>
  )
}

export default Layout